import { flow, property } from 'lodash';
import {
  dataSelectorFactory,
  isErrorSelectorFactory,
  isLoadingSelectorFactory,
  objectSelectorFactory,
} from 'utils/selectors/selectorFactories';
import { getPaginationOptions } from 'modules/Checks/selectors';
import { createSelector } from 'reselect';

const russianBankAccountsSlice = property('profile.bankAccounts');
export const russianBankAccountsObject = objectSelectorFactory(russianBankAccountsSlice);

export const russianBankAccountsData = dataSelectorFactory(russianBankAccountsObject);
export const russianBankAccountsLoading = isLoadingSelectorFactory(russianBankAccountsObject);
export const russianBankAccountsError = isErrorSelectorFactory(russianBankAccountsObject);

export const russianBankAccounts = flow(russianBankAccountsData, property('content'));
export const russianBankAccountsPaginationOption = flow(
  russianBankAccountsData,
  getPaginationOptions,
);

export const russianBankAccountsIsDataPresented = createSelector(
  russianBankAccountsSlice,
  (object) => object.get('isDataPresented'),
);
